<ng-container *ngIf="control.invalid && control.touched">
  <ng-container *ngFor="let err of errorKeys">
    <div>{{ getError(err) }}</div>
  </ng-container>
</ng-container>
